import React from "react";
import { Upload, Palette, Sparkles } from "lucide-react";

import uploadImg from "@/assets/providedassets/upload photo.jpeg";
import materialImg from "@/assets/providedassets/material photo.jpeg";
import visualizeImg from "@/assets/providedassets/vizulization.png";

const STEPS = [
  {
    icon: Upload,
    step: "Step 1",
    title: "Upload a photo",
    body: "Customers snap or upload a photo of their room — no special hardware, just a phone camera.",
    img: uploadImg,
  },
  {
    icon: Palette,
    step: "Step 2",
    title: "Choose a material",
    body: "Browse your catalog — tiles, furniture, paint, wallpaper and more — and pick a product to try.",
    img: materialImg,
  },
  {
    icon: Sparkles,
    step: "Step 3",
    title: "Visualize instantly",
    body: "AI renders the product into the real space in seconds, so customers see exactly what they're buying.",
    img: visualizeImg,
  },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="bg-neutral-50 py-16 sm:py-20 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <p className="text-sm font-bold uppercase tracking-widest text-primary">How it works</p>
          <h2 className="mt-3 text-3xl font-bold text-neutral-900 md:text-4xl">
            From photo to visualization in seconds
          </h2>
          <p className="mt-4 text-base text-neutral-500 sm:text-lg">
            Built for retailers, manufacturers, interior designers, and home improvement brands.
          </p>
        </div>

        <div className="mt-10 space-y-14 sm:mt-16 sm:space-y-20">
          {STEPS.map((step, i) => {
            const Icon = step.icon;
            const reversed = i % 2 === 1;
            return (
              <div
                key={step.title}
                className={`flex flex-col items-center gap-10 md:gap-16 ${
                  reversed ? "md:flex-row-reverse" : "md:flex-row"
                }`}
              >
                <div className="w-full md:w-1/2">
                  <img
                    src={step.img}
                    alt={step.title}
                    className="aspect-[3/4] w-full rounded-2xl object-cover shadow-lg shadow-neutral-900/5"
                  />
                </div>
                <div className="w-full md:w-1/2">
                  <div className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-primary/10 text-primary">
                    <Icon className="h-6 w-6" />
                  </div>
                  <p className="mt-4 text-sm font-bold uppercase tracking-widest text-primary">{step.step}</p>
                  <h3 className="mt-2 text-2xl font-bold text-neutral-900 md:text-3xl">{step.title}</h3>
                  <p className="mt-4 max-w-md text-lg leading-relaxed text-neutral-500">{step.body}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
